// Singleton fetch+edit wrapper for the supplier config. Fetches the (single)
// row, then mounts the SchemaForm-backed BillingSupplierConfigForm with the
// fetched record's id.

import { fetchBillingSupplierConfig } from 'actions/billing'
import BillingSupplierConfigForm from 'components/superuser/billing/BillingSupplierConfigForm'
import React from 'react'
import { connect } from 'react-redux'
import { Loader } from 'semantic-ui-react'

import { getBillingSupplierConfig } from 'selectors/billing'

class SupplierConfigContainer extends React.Component {
  componentDidMount () {
    this.props.fetch()
  }

  render () {
    const { config } = this.props
    if (!config) return <Loader active inline="centered"/>
    return <BillingSupplierConfigForm entityId={config.id}/>
  }
}

const mapStateToProps = (state, ownProps) => ({
  config: getBillingSupplierConfig(state, ownProps)
})

const mapDispatchToProps = (dispatch) => ({
  fetch: () => dispatch(fetchBillingSupplierConfig())
})

export default connect(mapStateToProps, mapDispatchToProps)(SupplierConfigContainer)
